import Axios from '@/services/axios-instance/axios.service';

class ReapplyService {
  async getReapplyPaymentInfo(id) {
    const { data } = await Axios.get(`/reapply/pay/${id}`);
    return data;
  }
  async submitReapplyPaymentInfo(id, form) {
    const { data } = await Axios.post(`/reapply/pay/${id}`, form);
    return data;
  }
  async makeChangeReapplyPaymentInfo(id, form) {
    const { data } = await Axios.post(`/reapply/form-make-change/${id}`, form);
    return data;
  }
  async getReapplyInfo(id) {
    const { data } = await Axios.get(`/reapply/form/${id}`);
    return data;
  }
  async submitReapplyInfo(id, form) {
    const { data } = await Axios.post(`/reapply/form/${id}`, form);
    return data;
  }
  async getReapplyQuestions(id) {
    const { data } = await Axios.get(`/reapply/questions/${id}`);
    return data;
  }
  async submitReapplyQuestions(id, form) {
    const { data } = await Axios.post(`/reapply/questions/${id}`, form);
    return data;
  }
}

export default new ReapplyService();
